import { createFileRoute } from '@tanstack/react-router';
import Reports from '../../components/Reports';

// No permission gate: matches the original (wouter) router, where /reports rendered for any
// logged-in user (no `access` prop). Visibility is controlled by the backend-driven main menu.
export const Route = createFileRoute('/_authenticated/reports')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'menu.manualReports',
        suffix: 'menu.reports',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ReportsRoute,
});

function ReportsRoute() {
  return <Reports />;
}
